import { useCallback } from "react";
import { memoryStore, useStore } from "../../../lib/store";
import type { Api } from "../../../services/api";

type ArticleListItem =
  Api["get"]["/webapp/public/articles"]["output"]["body"]["docs"][number];

const docsStore = memoryStore<ArticleListItem[]>([]);
const totalStore = memoryStore<number>(0);
const indexStore = memoryStore<number>(-1);

export function useArticleSwipeCache() {
  const [docs, setDocs] = useStore(docsStore);
  const [total] = useStore(totalStore);
  const [index, setIndex] = useStore(indexStore);

  const update = useCallback((newDocs: ArticleListItem[], newTotal: number) => {
    docsStore.set(newDocs);
    totalStore.set(newTotal);
  }, []);

  const clear = useCallback(() => {
    docsStore.set([]);
    totalStore.set(0);
    indexStore.set(-1);
  }, []);

  return {
    docs,
    setDocs,
    total,
    index,
    setIndex,
    update,
    clear,
  };
}
